//---OBJECT-ACTIONS-OAFORM-STARTS---//
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";
import { AlternatingList } from "../../../theme/StyledFields";
import { TypeFieldSchema } from "../../types/types";
import { OAFormProps, useForm } from "../FormProvider";

export const OAFormPayments: React.FC<OAFormProps<"Payments">> = ({ onSuccess }) => {

  const { renderField, handleSubmit, handleDelete, errors, navItem, entity, syncing } = useForm<"Payments">();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  async function saveEntity() {
    handleSubmit().then((newentity) => {
      if (onSuccess) {
        onSuccess(newentity);
      } else {
        navigate(`/${navItem.segment}/${newentity.id}`);
      }
      enqueueSnackbar(`Payments saved`);
    }).catch(error => {
      console.error(error);
      enqueueSnackbar("Save failed");
    });
  }

  function deleteEntity() {
    handleDelete().then((msg) => {
      enqueueSnackbar(`Payments saved`);
    }).catch(error => {
      console.error(error);
      enqueueSnackbar("Delete failed");
    });
  }

  return (
    <AlternatingList container spacing={4} p={1} justifyContent={'space-between'} wrap={"wrap"} >
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["athlete"], 0, { fullWidth: true })}
      </Grid>
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["preferred_coach"], 0, { fullWidth: true })}
      </Grid>
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["course"], 0, { fullWidth: true })}
      </Grid>
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["paid"], 0, { fullWidth: true })}
      </Grid>
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["status"], 0, { fullWidth: true })}
      </Grid>
      <Grid item xs={12} >
        {renderField(TypeFieldSchema["Payments"]["subscription_ends"], 0, { fullWidth: true })}
      </Grid>

      {errors["general"] && <Typography variant={"body1"} color={"error"}>{errors["general"]}</Typography>}

      <Grid container item xs={12} justifyContent="space-between">
        <Button startIcon={syncing ? <CircularProgress color={"inherit"} size={18} /> : null}
          disabled={syncing}
          aria-label={"Submit"}
          variant="contained" color="primary" onClick={saveEntity}>
          Save
        </Button>
        {entity?.id && entity?.id > 0 ? <Button
          startIcon={syncing ? <CircularProgress color={"inherit"} size={18} /> : null}
          disabled={syncing}
          variant="outlined" color="secondary" onClick={deleteEntity}>
          Delete
        </Button> : null
        }
      </Grid>
    </AlternatingList>
  );

};

export default OAFormPayments;
//---OBJECT-ACTIONS-OAFORM-ENDS---//